import {
  BoardResponse,
  ListResponse,
  MakerResponse,
  PostResponse,
  ProductVariationWithProductResponse,
  ProjectResponse,
  TeamResponse,
} from "@/web-client/api";

export enum SectionId {
  Maker = "maker",
  List = "list",
  BuildingMaterial = "building_material",
  Interior = "interior",
  Project = "project",
  Post = "post",
  Board = "board",
  Team = "team",
}

export type SearchResult = {
  section_id: SectionId;
  label: string;
  count: number;
  items: (
    | ProjectResponse
    | MakerResponse
    | PostResponse
    | ProductVariationWithProductResponse
    | ListResponse
    | BoardResponse
    | TeamResponse
  )[];
};
